import { render, staticRenderFns } from "./MultiCreate.vue?vue&type=template&id=6a7060ee&scoped=true&"
import script from "./MultiCreate.vue?vue&type=script&lang=js&"
export * from "./MultiCreate.vue?vue&type=script&lang=js&"
import style0 from "./MultiCreate.vue?vue&type=style&index=0&id=6a7060ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7060ee",
  null
  
)

export default component.exports